import React,{Component} from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import {
  Row,
  Col,
  Card,
  Button,
  FormGroup,
  Label,
  Alert
} from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {  Link } from "react-router-dom";
import LoadingScreen from 'react-loading-screen';
import {
  Textbox,

} from "react-inputs-validation";
import { encriptarTrama, encriptarContrasenia } from "../../utils/Encriptar";
import { verificarTokenFetch, recuperarContraseniaOK, limpiarVerificarToken } from "../../redux/actions/aLogin";

class VerificarToken extends Component {


  constructor(props){
    super(props);
    this.state = {
      contraseniaActual: "",
      contraseniaNueva: "",
      contraseniaNuevaConfirmar: "",
      validate:false,
      hasContraseniaActualError:true,
      hasContraseniaNuevaError:true,
      hasConfirmacionError:true
    };
    this.validateForm=this.validateForm.bind(this);
    }

    componentDidMount(){
      this.props.limpiarDatos();
    }


  onChangeContraseniaNueva=(event)=>{
    //console.log(event.target.value)
    this.setState({
      contraseniaNueva:event.target.value
    });
    if(this.props.datosVerificarToken.verificarTokenError){
      this.props.limpiarDatos();
    }
   

  }
onChangeContraseniaNuevaConfirmar=(event)=>{
  this.setState({
    contraseniaNuevaConfirmar:event.target.value
  });
  if(this.props.datosVerificarToken.verificarTokenError){
    this.props.limpiarDatos();
  }

}

handleOnClick=()=>{


const param64=decodeURIComponent(
  escape(window.atob(this.props.match.params.token))
)

//console.log("param64",typeof param64);
let jsonToken= JSON.parse(param64);
//console.log("jsontoken",jsonToken);
//console.log("jsontoken",typeof jsonToken);
const cliCodigoCoreToken=jsonToken.cliCodigoCore;
jsonToken=jsonToken.token;

//console.log("jsontoken2",jsonToken);
  var datosCambio={
    cliCodigoCore:cliCodigoCoreToken,
    token:jsonToken,
    cliPasswordNueva:encriptarContrasenia(this.state.contraseniaNueva),
    cliPasswordNuevaSinSha1:this.state.contraseniaNueva,

  };
  
  datosCambio = JSON.stringify(datosCambio);
  //console.log("camnio",datosCambio)
  const encrypted64Cambio = encriptarTrama(datosCambio);
  this.props.VerificarToken(encrypted64Cambio);
}



toggleValidating(validate) {
  this.setState({ validate });
}
validateForm(e) {
  e.preventDefault();
  this.toggleValidating(true);
  const {
    hasContraseniaActualError,
    hasContraseniaNuevaError,
    hasConfirmacionError
  } = this.state;
  //console.log('All validated!',this.state);
  if ( !hasContraseniaNuevaError && !hasConfirmacionError) {
    this.handleOnClick()
    //console.log('All validated!');
  }
}



  render(){
    const {
      showLogo,
      onSelectIniciarSesion,
      onChangeFormulario,
      handleCambiarContrasenia,datosUsuario
    } = this.props;
    let isLoading=this.props.datosVerificarToken.verificarTokenIsLoading===undefined?false:this.props.datosVerificarToken.verificarTokenIsLoading;
    
//console.log("isLoadingggg ",isLoading)

    const {validate,contraseniaNueva,contraseniaNuevaConfirmar}=this.state;
    return (
      <LoadingScreen
      loading={isLoading}
      bgColor='#f1f1f1'
      spinnerColor='#001871'
      textColor='#676767'
      logoSrc={logo}
      text='Verificando...'
    > 
      <main className="bg-light">
        <Row
          style={{
            height: "100vh",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
        <Col md={6} lg={4}>
            <Card body>
              <form onSubmit={this.validateForm}>
                {showLogo && (
                  <div className="text-center pb-4">
                    <img
                      src={logo}
                      className="login-logo"
                      style={{ cursor: "pointer" }}
                      alt="logo"
                    />
                  </div>
                )}
                
                
                
            
                       
                        {(
                          <div className="text-center pb-4">
                            <img
                              src={logo}
                              className="login-logo"
                              style={{ cursor: "pointer" }}
                              alt="logo"
                            />
                          </div>
                        )}
                           
                          {!this.props.datosVerificarToken.recuperarContraseniaOK && <FormGroup>
                            <Label for="examplePassword">Nueva Contraseña</Label>

                   <Textbox
                      tabIndex="1" 
                        type="password"
                        value = {contraseniaNueva}
                        name="nuevacontrasena"
                        id="nuevacontrasena"
                        placeholder="Ingresa tu nueva contraseña"
                        classNameInput={"form-control"}
                        onChange={(contraseniaNueva, e) => {
                          this.setState({contraseniaNueva:contraseniaNueva})
                          this.props.limpiarDatos();
                          //handleChangeCorreo(e)
                        }}
                        validate={validate}
                        validationCallback={res =>
                          //console.log(res)
                          this.setState({ hasContraseniaNuevaError: res, validate: false })
                        } // Optional.[Func].Default: none. Return the validation result.
                        onBlur={e => {
                          this.setState({blur:true})
                        }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.

                        validationOption={{
                          name: "actualcontrasena", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true,
                         msgOnError:"Por favor ingrese su contraseña", // Optional.[Bool].Default: true. To determin if it is a required field.

                        }}
                      />

                          </FormGroup>}
                          
{    !this.props.datosVerificarToken.recuperarContraseniaOK &&                      <FormGroup>
                            <Label for="examplePassword">
                              Confirmar Nueva Contraseña
                            </Label>
                            <Textbox
                      tabIndex="1" 
                        type="password"
                        value = {contraseniaNuevaConfirmar}
                        name="nuevacontrasenaconfirmar"
                        id="nuevacontrasenaconfirmar"
                        placeholder="Reingrese su nueva contraseña"
                        classNameInput={"form-control"}
                        onChange={(contraseniaNuevaConfirmar, e) => {
                          this.setState({contraseniaNuevaConfirmar:contraseniaNuevaConfirmar})
                          this.props.limpiarDatos();
                          //handleChangeCorreo(e)
                        }}
                        validate={validate}
                        validationCallback={res =>
                          //console.log(res)
                          this.setState({ hasConfirmacionError: res, validate: false })
                        } // Optional.[Func].Default: none. Return the validation result.
                        onBlur={e => {
                          this.setState({blur:true})
                       
                        }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.

                        validationOption={{
                          name: "nuevacontrasenaconfirmar", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true,
                         msgOnError:"Las contraseñas deben coincidir", // Optional.[Bool].Default: true. To determin if it is a required field.
                           customFunc: res => { // Optional.[Func].Default: none. Custom function. Returns true or err message
                            //console.log(contraseniaNueva,contraseniaNuevaConfirmar) 
                            if (res !== contraseniaNueva) {
                               //console.log(contraseniaNueva)
                               return 'Las contraseñas deben coincidir';
                             }
                             return true;
                           }
                        }}
                      />
                          </FormGroup>}

                          
                          <div className="text-center">
                          {!this.props.datosVerificarToken.recuperarContraseniaOK &&
                          <Button
                            className="bg-gradient-theme-left border-0"
                            size="lg"
                            block
                            onClick={this.validateForm}
                          >
                            {"CAMBIAR CONTRASEÑA"}
                          </Button>}
                          </div>
                          <div className="text-center pt-1">
                            <h6>
                              <p />
                              <Link to={`/login`}>Iniciar Sesión</Link>
                            </h6>
                          </div>
                          {this.props.datosVerificarToken.recuperarContraseniaOK && <Alert color="success">
                        <center><p>Estimado Usuario. Su contraseña ha sido modificada exitosamente</p></center>
                      </Alert>}
                      {this.props.datosVerificarToken.verificarTokenError && <Alert color="warning">
                        <center><p>No se pudo procesar su solicitud. Por favor intente más tarde</p></center>
                      </Alert>}
                        
                    
                </form>
        </Card>
          </Col>
        </Row>
        </main>
        </LoadingScreen>
    );
  }

};

const mapStateToProps = state => ({
  datosVerificarToken: state.datosVerificarToken,
  datosUsuario: state.datosUsuarios
});

const mapDispatchToProps = dispatch => {
  return {
    VerificarToken: dataCambio => dispatch(verificarTokenFetch(dataCambio)),
    setRecuperarContrasenia: estado => dispatch(recuperarContraseniaOK(estado)),
    limpiarDatos:() => dispatch(limpiarVerificarToken())
  };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(VerificarToken));
